import axios from "axios";
import { fromCommissionData } from "../components/CommissionList";
import swal from "sweetalert";
import { parseNumber } from "../../../../utils/numberFormatter";

export const usePayableActions = (
  BASE_URL,
  userLoggedID,
  formatNumberWithComma,
) => {
  // const rejectPOTransaction = async (e, id) => {
  //   e.preventDefault();

  //   const confirmed = await swal({
  //     title: "Reject this payable?",
  //     icon: "warning",
  //     buttons: true,
  //     dangerMode: true,
  //   });

  //   if (!confirmed) return;

  //   const response = await axios.put(
  //     `${BASE_URL}/payable/approvedPayable/${id}`,
  //     {
  //       status: "Rejected",
  //       approved_by: userLoggedID,
  //     },
  //   );

  //   if (response.status === 200) {
  //     await swal({
  //       title: "Rejected successfully!",
  //       text: "The Payment has been rejected successfully.",
  //       icon: "success",
  //     });
  //   }
  // };

  // const approvePOTransaction = async (
  //   e,
  //   id,
  //   status,
  //   dataProduct,
  //   vendorId,
  //   purchaseDate,
  //   transaction_id,
  //   warehouseID,
  //   currencyRate,
  //   currencyName,
  //   FinalPayableAmount,
  // ) => {
  //   e.preventDefault();
  //   try {
  //     // Assuming you want to send all `product_id`s from `dataProduct`

  //     swal({
  //       title: "Approve this payable?",
  //       text: "",
  //       icon: "warning",
  //       buttons: true,
  //       dangerMode: true,
  //     }).then(async (confirmed) => {
  //       if (confirmed) {
  //         console.log(dataProduct);
  //         const productData = dataProduct.map((data) => ({
  //           product_id: data.productId,
  //           costing: data.unitPrice,
  //           weight: data.weight,
  //           moistureType: data.moisture_type,
  //           netWeight: data.net_weight,
  //         }));

  //         // For payable journal creation
  //         const { totalQuantity, averageUnitPrice } = (() => {
  //           // Get total quantity
  //           const totalQuantity = productData.reduce(
  //             (acc, value) => acc + value.netWeight,
  //             0,
  //           );

  //           // Sum up unit prices
  //           const { totalCount, totalUnitPrice } = productData.reduce(
  //             (acc, value) => {
  //               acc.totalCount += 1;
  //               acc.totalUnitPrice += value.costing;
  //               return acc;
  //             },
  //             { totalCount: 0, totalUnitPrice: 0 },
  //           );

  //           // Calculate average safely (avoid division by 0)
  //           const averageUnitPrice =
  //             totalCount > 0 ? totalUnitPrice / totalCount : 0;

  //           return { totalQuantity, averageUnitPrice };
  //         })();

  //         const response = await axios.put(
  //           `${BASE_URL}/payable/approvedPayable/${id}`,
  //           {
  //             status: status,
  //             products: productData,
  //             vendorId: vendorId,
  //             purchaseDate: purchaseDate,
  //             transaction_id: transaction_id,
  //             approved_by: userLoggedID,
  //             warehouseID: warehouseID,
  //             currencyRate: currencyRate,
  //             currencyName: currencyName,
  //             payableJournal: {
  //               totalAmount: FinalPayableAmount.toFixed(2),
  //               totalQuantity,
  //               averageUnitPrice,
  //             },
  //           },
  //         );

  //         if (response.status === 200) {
  //           swal({
  //             title: "Approved successfully!",
  //             text: "The Payment has been approved successfully.",
  //             icon: "success",
  //             button: "OK",
  //           }).then(() => {
  //             // navigate(`/Purchases/Payable?page=${searchParams.get("page")}`);
  //           });
  //         } else {
  //           swal({
  //             icon: "error",
  //             title: "Something went wrong",
  //             text: "Please contact our support",
  //           });
  //         }
  //       } else {
  //         swal.close();
  //       }
  //     });
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  // 401 = imbalance checker / invalid cutoff from approvedPayable
  const showApprovalError = (err) => {
    if (err.response?.status === 401) {
      swal({
        icon: "error",
        title: err.response.data.title,
        text: err.response.data.message,
      });
    } else {
      swal({
        icon: "error",
        title: "Something went wrong",
        text: "Please contact our support",
      });
    }
  };

  const rejectPOTransaction = async (e, id) => {
    e.preventDefault();

    const confirmed = await swal({
      title: "Reject this payable?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (!confirmed) return false;

    try {
      const response = await axios.put(
        `${BASE_URL}/payable/approvedPayable/${id}`,
        {
          status: "Rejected",
          approved_by: userLoggedID,
        },
      );

      if (response.status === 200) {
        await swal({
          title: "Rejected successfully!",
          text: "The Payment has been rejected successfully.",
          icon: "success",
        });
        return true;
      }

      return false;
    } catch (err) {
      console.log(err);
      showApprovalError(err);
      return false;
    }
  };
  const approvePOTransaction = async (
    e,
    id,
    status,
    dataProduct,
    vendorId,
    purchaseDate,
    transaction_id,
    warehouseID,
    currencyRate,
    currencyName,
    FinalPayableAmount,
  ) => {
    e.preventDefault();
    try {
      const confirmed = await swal({
        title: "Approve this payable?",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      });

      if (!confirmed) return false; // <-- return false if cancelled

      const productData = dataProduct.map((data) => ({
        product_id: data.productId,
        costing: data.unitPrice,
        weight: data.weight,
        moistureType: data.moisture_type,
        netWeight: data.net_weight,
      }));

      // netWeight / costing come from the form as formatted strings
      // (e.g. "1,000"), so parse them or the reduce concatenates
      const { totalQuantity, averageUnitPrice } = (() => {
        const totalQuantity = productData.reduce(
          (acc, value) => acc + (parseNumber(value.netWeight) || 0),
          0,
        );
        const { totalCount, totalUnitPrice } = productData.reduce(
          (acc, value) => {
            acc.totalCount += 1;
            acc.totalUnitPrice += parseNumber(value.costing) || 0;
            return acc;
          },
          { totalCount: 0, totalUnitPrice: 0 },
        );
        const averageUnitPrice =
          totalCount > 0 ? totalUnitPrice / totalCount : 0;
        return { totalQuantity, averageUnitPrice };
      })();

      const response = await axios.put(
        `${BASE_URL}/payable/approvedPayable/${id}`,
        {
          status,
          products: productData,
          vendorId,
          purchaseDate,
          transaction_id,
          approved_by: userLoggedID,
          warehouseID,
          currencyRate,
          currencyName,
          payableJournal: {
            totalAmount: FinalPayableAmount.toFixed(2),
            totalQuantity,
            averageUnitPrice,
          },
        },
      );

      if (response.status === 200) {
        await swal({
          title: "Approved successfully!",
          text: "The Payment has been approved successfully.",
          icon: "success",
          button: "OK",
        });
        return true; // <-- return true on success
      } else {
        await swal({
          icon: "error",
          title: "Something went wrong",
          text: "Please contact our support",
        });
        return false;
      }
    } catch (err) {
      console.log(err);
      showApprovalError(err);
      return false;
    }
  };
  const fetchDataForView = async (
    id,
    setCurrent_status,
    setStateValidation,
    reset,
    setIsSpecialTax,
    setIsPercent,
    setPrimary_discount,
    setVendorSelected,
    fetchProductData,
    fetchPayableProduct,
    setOtherFees,
  ) => {
    axios
      .get(`${BASE_URL}/payable/getInfo`, {
        params: { id },
      })
      .then((res) => {
        if (res.data) {
          const data = res.data;
          //   setIsCutoffPosted(res.data.isCutoffPosted);
          //   setIsCutoffExists(res.data.cutoffExists);
          //   setEditableTaxId(res.data.tax_id || "");
          //   setEditableTaxRate(res.data.tax_rate || 0);
          //   setIsSpecialTax(res.data.isSpecialTax || false);
          setCurrent_status(data.status);
          setIsSpecialTax(data.isSpecialTax);
          setIsPercent(data.isPercent_Discount);
          setPrimary_discount(data.discount_value);
          setVendorSelected(true);
          fetchProductData(data.vendor_id);
          fetchPayableProduct(data.vendor_id);

          setStateValidation({
            isCutoffPosted: data.isCutoffPosted,
            isCutoffExists: data.cutoffExists,
            isAdded: data.isAdded,
          });

          setOtherFees(
            data.payable_other_fees.map((fee) => ({
              id: fee.id,
              feeName: fee.fee_name,
              feeAmount: fee.fee_amount,
            })),
          );

          console.log(data);

          reset({
            transactionId: data.transaction_id,
            clientTransactionId: data.client_transaction_id,
            warehouseId: data.warehouse_id,
            vendorId: data.vendor_id,
            modeOfPayment: data.MOP,
            customerType: data.domestic_type,
            trackingNumber: data.tracking_number,
            dueDate: data.due_date,
            // weightedQuantity: "",
            // netWeight: data.,
            weighingFee: data.weighing_fee,
            purchaseDate: data.purchaseDate,
            description: data.description,
            currencyId: data.currencyId,
            containerNumber: data.container_number,
            pier: data.pier,
            currencyRate: data.rate,
            vat: data.vat_percent,
            taxId: data.tax_id,
            taxRate: data.tax_rate,
            commissions: fromCommissionData(data.payable_commissions),
            items: data.payable_products.map((item) => ({
              product_vendor_id: item.product_vendor_id,
              productId: item.product_tag_vendor.product_list.product_id,
              productCode: item.product_tag_vendor.product_list.product_code,
              productName: item.product_tag_vendor.product_list.product_name,
              moistureType: item.moisture_type ?? "%",
              moisture: item.moisture ?? 0,
              weight: formatNumberWithComma(item.weight) ?? "",
              net_weight: formatNumberWithComma(item.net_weight) ?? 0,
              unitPrice: formatNumberWithComma(item.unitPrice) ?? 0,
              supplier_price: item.product_tag_vendor.product_price ?? 0,
              original_php_price: item.product_tag_vendor.product_price ?? 0,
              totalPrice: formatNumberWithComma(
                item.unitPrice * item.net_weight,
              ),
              discount: item.discount ? String(item.discount) : "",
              discountType: item.discount_type ?? "%",
            })),
          });
        }
      })
      .catch((err) => console.log(err));

    //     product_vendor_id: "",..
    // productId: "",
    // productCode: "",
    // productName: "",
    // moistureType: "%",
    // moisture: 0,
    // weight: "",
    // net_weight: 0,
    // unitPrice: 0,
    // supplier_price: 0,
    // original_php_price: 0, // Stores the raw PHP base price for currency re-conversion
    // totalPrice: 0,
  };

  const handleSaveUpdateChanges = async (
    tracking_number,
    domestic_type,
    purchaseDate,
    vendorId,
    warehouseId,
    due_date,
    containerNumber,
    pier,
    currencyId,
    description,
    id,
    dataProduct,
    currencyRate,
    weighingFee,
    totalAmount,
    vat,
    tax_id,
    tax_rate,
    isSpecialTax,
    discount,
    discountType,
    otherFees,
    clientTransactionId,
    setIsEditable,
    commissions = "[]",
  ) => {
    // FIX: Failsafe to guarantee the array goes into the URL as a strict JSON string
    const safeOtherFees =
      typeof otherFees === "string" ? otherFees : JSON.stringify(otherFees);

    swal({
      title: "Update purchase information?",
      text: "Action cannot be undone!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((confirmed) => {
      if (confirmed) {
        axios
          .put(`${BASE_URL}/payable/new_updatePO`, null, {
            params: {
              vendorId,
              warehouseID: warehouseId,
              due_date,
              purchaseDate,
              containerNumber,
              pier,
              currencyId,
              description,
              domestic_type,
              tracking_number:
                domestic_type === "local" ? null : tracking_number,
              id,
              dataProduct,
              userLoggedID,
              currencyRate,
              weighingFee,
              totalAmount: totalAmount.toFixed(2),
              vat: vat || 0,
              tax_id,
              tax_rate,
              isSpecialTax,
              discount,
              discountType,
              otherFees: safeOtherFees, // <-- Send the safe string
              clientTransactionId,
              commissions, // JSON string, same as otherFees
            },
          })
          .then((res) => {
            if (res.status === 200) {
              swal({
                title: "Success",
                text: "Purchase updated successfully",
                icon: "success",
                buttons: false,
                timer: 2000,
                dangerMode: true,
              }).then(() => {
                setIsEditable(false);
              });
            } else if (res.status === 201) {
              swal({
                title: "Opppss!",
                text: "Cutoff already posted for this purchase date.",
                icon: "warning",
                buttons: false,
                timer: 2000,
                dangerMode: true,
              });
            } else if (res.status === 202) {
              swal({
                title: "Opppss!",
                text: res.data?.message,
                icon: "warning",
                dangerMode: true,
              });
            } else if (res.status === 203) {
              swal({
                title: "Opppss!",
                text: "This payable is already included in a payment and can no longer be edited.",
                icon: "warning",
                buttons: false,
                timer: 2500,
                dangerMode: true,
              });
            } else {
              swal({
                title: "Something Went Wrong",
                text: "Please contact your support immediately",
                icon: "error",
                buttons: false,
                timer: 2000,
                dangerMode: true,
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }

      // setConfirmation(false);
    });
  };

  return {
    rejectPOTransaction,
    approvePOTransaction,
    fetchDataForView,
    handleSaveUpdateChanges,
  };
};
